import React from 'react'
import { useUserRank } from '@components/TipsLeaderboard/useUserRank'
import { UserRankPill } from '@components/UserRankBadge/UserRankBadge'
import { Box, Paragraph } from '@ui'

type Props = {
    userId: string | undefined
}

export const UserBadges = (props: Props) => {
    const { userId } = props
    const { rank } = useUserRank(userId)

    // Only render the badge if the user has a rank and it's in the top 3
    if (typeof rank !== 'number' || rank > 3 || rank < 1) {
        return null
    }

    return (
        <Box gap padding background="level2" borderRadius="sm">
            <Paragraph fontWeight="strong" color="default">
                Badges
            </Paragraph>
            {rank && <UserRankPill rank={rank} />}
        </Box>
    )
}
